export const GET_SHIPPING_ADDRESSES = "GET_SHIPPING_ADDRESSES"
export const UPDATE_SHIPPING_ADDRESS = "UPDATE_SHIPPING_ADDRESS"
export const UPDATE_BILLING_ADDRESS = "UPDATE_BILLING_ADDRESS"
export const CREATE_BILLING_ADDRESS = "CREATE_BILLING_ADDRESS"
export const CREATE_SHIPPING_ADDRESS = "CREATE_SHIPPING_ADDRESS"
export const GET_BILLING_ADDRESS = "GET_BILLING_ADDRESS"
export const UPDATE_CUSTOMER_INFO = "UPDATE_CUSTOMER_INFO"
export const ADD_SHIPPING_ADDRESS = "ADD_SHIPPING_ADDRESS"
export const VALIDATE_VAT = "VALIDATE_VAT"

export const GET_SERVICE_CENTER_BY_CUSTOMER = "GET_SERVICE_CENTER_BY_CUSTOMER"
export const CREATE_SERVICE_CENTER = "CREATE_SERVICE_CENTER"
export const EDIT_SERVICE_CENTER = "EDIT_SERVICE_CENTER"
export const GET_SERVICE_CENTERS = "GET_SERVICE_CENTERS"
export const GET_SERVICE_CENTERS_BY_CATEGORY = 'GET_SERVICE_CENTERS_BY_CATEGORY'

